// IMPORTS
// Modules
import { useState, useEffect } from 'react';
import $ from 'jquery';
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { fieldModel } from './../_variables';
import FieldTypes from './FieldTypes';


// COMPONENT
export default function Field (props) {
   // States and Variables
   const [optionsField, setOptionsField] = useState(false);

   // On-Load
   useEffect(function () {
      if (props.content.type.value == "select") {
         setOptionsField(true);
      }
   }, []);

   // Functions
   const updateField = function () {
      OHSCRUD({
         url: '/v1/oneport/fields/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('oneport-field'),
         success: function (data) {
            var temp = props.parent.fields;
            temp[props.index] = OHSListDataFormatter(data[0], fieldModel);
            props.parent.setFields(temp)
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteField = function () {
      OHSCRUD({
         url: '/v1/oneport/fields/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.fields;
            temp.splice(props.index, 1);
            props.parent.setFields(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this field?",
         showSuccessPopup: true
      });
   }
   const toggleOptionsField = function () {
      if ($('#oneport-field-type').val() == "select") {
         setOptionsField(true);
      } else {
         setOptionsField(false);
      }
   }

   // Component
   return (
      <div id='oneport-field' className='oneport-field' onKeyDown={(e) => {OHSFormSubmitListener(e, updateField);}}>
         <OHSFormItem onehive={props.onehive} title="Name">
            <input type='text' className='ohsinput' data-ohsformdata='name' defaultValue={props.content.name.value} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Type">
            <select id='oneport-field-type' className='ohsinput' data-ohsformdata='type' disabled={true} onChange={toggleOptionsField} defaultValue={props.content.type.value}>
               <FieldTypes onehive={props.onehive} />
            </select>
         </OHSFormItem>
         {optionsField &&
            <OHSFormItem onehive={props.onehive} title="Options">
               <textarea className='ohsinput' data-ohsformdata='options' placeholder='Enter one option per line' defaultValue={props.content.options.value} />
            </OHSFormItem>
         }
         <OHSFormItem onehive={props.onehive} title="Required?">
            <input type='checkbox' className='ohsinput' data-ohsformdata='required' defaultChecked={Boolean(Number(props.content.required.value))} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Use for Availability?">
            <input type='checkbox' className='ohsinput' data-ohsformdata='use_for_availability' defaultChecked={Boolean(Number(props.content.use_for_availability.value))} />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Value in List?">
            <input type='checkbox' className='ohsinput' data-ohsformdata='value_in_list' defaultChecked={Boolean(Number(props.content.value_in_list.value))} />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateField} clear={() => {OHSFormDataClearer('oneport-field');}} delete={deleteField} keyListener={true} />
      </div>
   );
}